// Custom components
import Navigation from './Navigation';
import Footer from './Footer';
import RecipeList from './sub-components/RecipeList';

const App = () => {
	return (
		<div className="main">
			<Navigation />
			<RecipeList />
			<Footer />
		</div>
	)
}

export default App
